module.exports = "https://cdn.hellotech.com/client-assets/verified_9fe3cd8d9e80c868b8af862ff6679e14.svg";